module.exports = __webpack_public_path__ + "media/Stepbrother.6ee472d2.mp3";